import { render } from "./OverlayComponent.vue?vue&type=template&id=3464f9b1"
import script from "./OverlayComponent.vue?vue&type=script&lang=js"
export * from "./OverlayComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__